<div class="tabs-container padding-bottom">
    <tabs (tabClicked)="onTabClicked()">
        <tab title="Not Submitted">
            <ag-grid-angular #grid class="data-grid " [rowData]="notSubmittedData" [gridOptions]="notSubmittedGridOptions"  [attr.aria-label]="widgetTitle + ' - Not Submitted'">
            </ag-grid-angular>
        </tab>
        <tab title="Pending">
            <ag-grid-angular #grid class="data-grid " [rowData]="pendingData" [gridOptions]="pendingGridOptions"  [attr.aria-label]="widgetTitle + ' - Pending'">
            </ag-grid-angular>
        </tab>
        <tab title="Returned">
            <ag-grid-angular #grid class="data-grid " [rowData]="returnedData" [gridOptions]="returnedGridOptions"  [attr.aria-label]="widgetTitle + ' - Returned'">
            </ag-grid-angular>
        </tab>
        <tab title="Approved">
            <ag-grid-angular #grid class="data-grid " [rowData]="approvedPermitData" [gridOptions]="approvedGridOptions"  [attr.aria-label]="widgetTitle + ' - Approved'">
            </ag-grid-angular>
        </tab>
        <tab title="Denied">
            <ag-grid-angular #grid class="data-grid " [rowData]="permitDeniedData" [gridOptions]="permitDeniedGridOptions"  [attr.aria-label]="widgetTitle + ' - Denied'">
            </ag-grid-angular>
        </tab>
    </tabs>
</div>
